module.exports = __webpack_public_path__ + "static/media/detection_comp.4f52200c.gif";